import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Folder} from 'storyboard-renderer';
import {MediaLibraryService} from '../shared/media-library.service';
import {PromptModalComponent} from '../../shared/prompt-modal/prompt-modal.component';
import {Media} from 'storyboard-renderer';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-browse-media',
  templateUrl: './browse-media.component.html',
  styleUrls: ['./browse-media.component.scss']
})
export class BrowseMediaComponent implements OnInit {

  folders: Array<Folder> = [];
  rootFolder: Folder = new Folder(0, 'root_folder');

  creatingFolder = false;
  mediaLoading = false;
  uncategorizedFolderDropzoneHidden = true;
  @Input() userId = null;

  @Output() selectMediaEvent = new EventEmitter();

  constructor(private mediaLibraryService: MediaLibraryService, private modalService: NgbModal) {
  }

  ngOnInit() {
    // Load all storyboards
    this.getAllMedia();
  }

  getAllMedia(): void {

    this.mediaLoading = true;
    this.mediaLibraryService.getMediaInFolderedStructure({userId: this.userId}).then(folderContainer => {

      this.folders = folderContainer.folders;
      this.rootFolder = folderContainer.rootFolder;

      this.mediaLoading = false;
    }, () => {
      this.mediaLoading = false;
    });
  }


  moveItem($event: any, folder: Folder) {
    if ($event) {

      folder.items.push($event.dragData.item);

      const index = $event.dragData.folder.items.indexOf($event.dragData.item);
      $event.dragData.folder.items.splice(index, 1);
    }
  }

  newFolder() {
    this.creatingFolder = !this.creatingFolder;
  }

  deleteFolder(folder: Folder) {

    const modalRef = this.modalService.open(PromptModalComponent).result.then((result) => {
      this.mediaLibraryService.deleteFolder(folder, {userId: this.userId}).then(() => {
        this.getAllMedia();
      });
    });
  }

  cancelCreateFolder() {
    this.creatingFolder = false;
    // TODO cancel folder creating
  }

  saveFolder(event) {
    const newFolder: Folder = new Folder(0, event.folderName);

    this.mediaLibraryService.createFolder(newFolder, {userId: this.userId}).then(folder => {
      this.folders.push(folder);

      this.creatingFolder = false;
    });
  }

  delete(media: Media): void {

    const modalRef = this.modalService.open(PromptModalComponent).result.then((result) => {
      this.mediaLibraryService
          .delete(media)
          .then(() => {
            this.getAllMedia();
          })
    });
  }

  onSelectMedia(media: Media) {
    this.selectMediaEvent.next(media);
  }

  showDropzoneForUncategorizedFolder(){
    this.uncategorizedFolderDropzoneHidden = false;
  }

  hideDropzoneForUncategorizedFolder(){
    this.uncategorizedFolderDropzoneHidden = true;
  }

  isFolderForUncategorizedItems(folder: Folder){
    return folder && !folder.folder;
  }
}



// WEBPACK FOOTER //
// ./src/app/media-library/browse-media/browse-media.component.ts